//var api_url = 'http://iternaturastrapi.ferranmaso.com';
//var api_url = 'https://iternaturastrapi.cenobify.com'
//var token = 'hejoi32nyrt8rn32ued8fnsy78nr3ui2o1lkdkkajfidsa';

//  var api_url = "https://iternaturastrapi.ferranmaso.com";
//  var api_url = "https://catcar-wa.iec.cat/"
 var api_url = "https://strapiold.iternatura.es"
var api2_url = 'https://strapi.iternatura.es'

const projecteId = 14; // id strapi.iternatura.es


 var token = 'hejoi32nyrt8rn32ued8fnsy78nr3ui2o1lkdkkajfidsa';
 var tokenClio= 'NRA1tGCl8ZHetrLONKory8L7e4kB7i0I';
 var tokenTon = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9';
 var tokenCanet = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c';

 const TOKEN_CANET = "TOKEN_CANET"

 export default {
  api_url: api_url,
    api2_url,
  projecte: api_url +'/projectes?token=' + token,
  premis: api_url +'/premis',
  clio : api_url + '/projectes?token='+tokenClio,
  ton : api_url + '/projectes?token='+tokenTon,
  canetdemar : api_url + '/projectes?token='+tokenCanet,
  canetdemar2 : api2_url + '/projectes?token='+TOKEN_CANET,
    poi_all: api2_url + '/itineraris?projecte.id=' + projecteId,
    premis2: api2_url + '/premis?projecte=',

};